/**
 * Snap override UI state (Faz 11.2 — OCS Shift+RMB override grid).
 *
 * Carries the transient popup + Mid-between-two-points (M2P) two-click
 * calculator state. The actual snap override lives in useSnapStore
 * (overrideType) — this store only drives the DOM popup and the M2P flow.
 * Nothing here persists.
 */

import { create } from 'zustand';

interface SnapOverrideState {
    /** Override grid popup visible at the pointer. */
    visible: boolean;
    position: { x: number; y: number };
    /**
     * M2P calculator stage: 0 idle, 1 waiting for the first corner,
     * 2 waiting for the second. The midpoint is injected through the
     * dynamic-input pipeline (injectPointAtWorld) when stage 2 completes.
     */
    m2pStage: 0 | 1 | 2;
    m2pFirst: [number, number, number] | null;

    open: (x: number, y: number) => void;
    close: () => void;
    beginM2p: () => void;
    setM2pFirst: (p: [number, number, number]) => void;
    finishM2p: () => void;
    cancelM2p: () => void;
}

export const useSnapOverrideStore = create<SnapOverrideState>((set) => ({
    visible: false,
    position: { x: 0, y: 0 },
    m2pStage: 0,
    m2pFirst: null,

    open: (x, y) => set({ visible: true, position: { x, y } }),
    close: () => set({ visible: false }),
    beginM2p: () => set({ visible: false, m2pStage: 1, m2pFirst: null }),
    setM2pFirst: (p) => set({ m2pStage: 2, m2pFirst: p }),
    finishM2p: () => set({ m2pStage: 0, m2pFirst: null }),
    cancelM2p: () => set({ m2pStage: 0, m2pFirst: null }),
}));
